/*eslint complexity: off*/
import React, {
  useContext,
  useEffect,
  useState
}                           from 'react';
import { useTranslation }   from 'react-i18next';
import LocalHospitalIcon    from '@material-ui/icons/LocalHospital';
import {
  schedules,
  createDoctorSchedule,
  editDoctorSchedule,
}                           from '~/config/routes';
import { toast }            from 'react-toastify';
import { historyPropType }  from '~/config/routerPropTypes';
import Request              from '~/providers/Request';
import Context              from './context';
import Paper                from '~/components/Paper';
import ModalDelete          from '~/components/ModalDelete';
import InputShow            from '~/components/InputShow';
import PaperButtons         from '~/components/PaperButtons';
import DoctorScheduleRecord from '~/records/DoctorScheduleRecord';
import GridContainer        from '~/components/GridContainer';
import GridItem             from '~/components/GridItem';
import moment from 'moment';
import { Chip } from '@material-ui/core';
import dig from 'object-dig';
import { AbilityContext }   from '~/contexts/Can';

const attrName = (attr) => DoctorScheduleRecord.hummanAttributeName(attr);

function ShowDoctorSchedule({history}) {
  const { id } = history.location.route.getParams();
  const { records, addRecords } = useContext(Context);
  const [ record, setRecord ] = useState(new DoctorScheduleRecord());
  const { t } = useTranslation();
  const [loading, setLoading] = useState(!records || !records[id]);
  const [modal, setModal] = useState(false);
  const ability = useContext(AbilityContext);

  useEffect(() => {
    if(records && records[id]){
      setRecord(record.updateAttributes(records[id]) );
    }
    setLoading(true);
    Request.get(`/admin/schedules/${id}`, {})
      .then( response => {
        setLoading(false);
        addRecords({ data: [response.data] });
        setRecord( record.updateAttributes(response.data) );
      })
      .catch( e => {
        console.error(e);
        setLoading(false);
      });
  }, []);

  async function handleDelete(){
    setLoading(true);
    Request.del(`/admin/schedules/${id}`)
    .then(() => {
      toast.success(t('delete-toast-success'));
      history.push(schedules.spec);
    })
    .catch(() => {
      setLoading(false);
      toast.error(t('delete-toast-fail'));
    });
    setModal(false);
  }

  return (
    <Paper
      Icon={ LocalHospitalIcon }
      iconColor="blue"
      title={t('doctor_schedules.defSingular')}
      loading={ loading }
      actions={
        <PaperButtons
          id={ id }
          setModal={ability.can('delete', 'Schedules') ? setModal : null}
          backRoute={ schedules }
          newRoute={ability.can('new', 'Schedules') ? createDoctorSchedule : null}
          editRoute={ability.can('edit', 'Schedules') ? editDoctorSchedule : null}
        />}
      >

        <GridContainer>
          <GridItem xs={4} md={3}>
            <InputShow
              label={attrName('doctor')}
              value={dig(record.get('doctor'), 'name')}
            />
          </GridItem>
        </GridContainer>

        <GridContainer>
          <GridItem xs={4} md={3}>
            <InputShow
              label={attrName('begin_date')}
              value={record.get('begin_date') ? moment(record.get('begin_date').replace('Z', '')).format('DD/MM/YYYY') : null}
            />
          </GridItem>
          <GridItem xs={4} md={3}>
            <InputShow
              label={attrName('end_date')}
              value={record.get('end_date') ? moment(record.get('end_date').replace('Z', '')).format('DD/MM/YYYY') : null}
            />
          </GridItem>
        </GridContainer>

        <GridContainer>
          <GridItem xs={4} md={2}>
            <InputShow
              label={attrName('begin_time')}
              value={record.get('begin_time') ? record.get('begin_time').split(':').slice(0, 2).join(':') : null}
            />
          </GridItem>
          <GridItem xs={4} md={2}>
            <InputShow
              label={attrName('end_time')}
              value={record.get('end_time') ? record.get('end_time').split(':').slice(0, 2).join(':') : null}
            />
          </GridItem>
        </GridContainer>

        <GridContainer>
          <GridItem md={12}>
            <Chip
              style={{margin: 3}}
              label={attrName('is_sunday')}
              color={record.get('is_sunday') ? 'primary' : 'default'}
            />
            <Chip
              style={{margin: 3}}
              label={attrName('is_monday')}
              color={record.get('is_monday') ? 'primary' : 'default'}
            />
            <Chip
              style={{margin: 3}}
              label={attrName('is_tuesday')}
              color={record.get('is_tuesday') ? 'primary' : 'default'}
            />
            <Chip
              style={{margin: 3}}
              label={attrName('is_wednesday')}
              color={record.get('is_wednesday') ? 'primary' : 'default'}
            />
            <Chip
              style={{margin: 3}}
              label={attrName('is_thursday')}
              color={record.get('is_thursday') ? 'primary' : 'default'}
            />
            <Chip
              style={{margin: 3}}
              label={attrName('is_friday')}
              color={record.get('is_friday') ? 'primary' : 'default'}
            />
            <Chip
              style={{margin: 3}}
              label={attrName('is_saturday')}
              color={record.get('is_saturday') ? 'primary' : 'default'}
            />

          </GridItem>
        </GridContainer>

        <GridContainer>
          <GridItem xs={6} md={2}>
            <InputShow
              label={attrName('is_closed')}
              value={record.get('is_closed') }
              type='boolean'
            />
          </GridItem>
        </GridContainer>

        <ModalDelete
          modal={modal}
          onClose={() => {
            setModal(false);
          }}
          name={record.get('name')}
          id={record.get('id')}
          deleteAction={handleDelete}
        />
      </Paper>
  );
}

  ShowDoctorSchedule.propTypes={
    history: historyPropType,
  };

export default ShowDoctorSchedule;
